import { mergeProps } from '@react-aria/utils';

export function mergeNonNullProps(
  ...propsArray: { [key: string]: any }[]
): ReturnType<typeof mergeProps> {
  return mergeProps(
    ...propsArray.map((props) =>
      Object.fromEntries(
        Object.entries(props).filter(([, value]) => value != null)
      )
    )
  );
}
